import { useEffect, useState } from "react";

const RADIUS = 48;
const STROKE = 8;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

export default function ScoreRing({ score, size = 120 }) {
  const [offset, setOffset] = useState(CIRCUMFERENCE);

  useEffect(() => {
    if (score == null) {
      setOffset(CIRCUMFERENCE);
      return;
    }
    const pct = Math.max(0, Math.min(10, score)) / 10;
    const timer = setTimeout(() => {
      setOffset(CIRCUMFERENCE * (1 - pct));
    }, 100);
    return () => clearTimeout(timer);
  }, [score]);

  const cx = size / 2;
  const cy = size / 2;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      data-testid="score-ring"
    >
      {/* Track */}
      <circle
        cx={cx} cy={cy} r={RADIUS}
        fill="none"
        stroke="#F3F3F3"
        strokeWidth={STROKE}
      />
      {/* Progress */}
      <circle
        cx={cx} cy={cy} r={RADIUS}
        fill="none"
        stroke="#FA7268"
        strokeWidth={STROKE}
        strokeLinecap="round"
        strokeDasharray={CIRCUMFERENCE}
        strokeDashoffset={offset}
        transform={`rotate(-90 ${cx} ${cy})`}
        style={{ transition: "stroke-dashoffset 1s ease-out" }}
      />
      {/* Score */}
      <text
        x={cx} y={cy - 6}
        textAnchor="middle"
        fill="#1A1A1A"
        fontSize={score == null ? "16" : "22"}
        fontWeight="700"
        fontFamily="Manrope, sans-serif"
      >
        {score != null ? score.toFixed(1) : "—"}
      </text>
      <text
        x={cx} y={cy + 12}
        textAnchor="middle"
        fill="#999"
        fontSize="11"
        fontFamily="Inter, sans-serif"
      >
        out of 10
      </text>
    </svg>
  );
}
